import { createFileRoute } from '@tanstack/react-router';
import { PageStub } from '@/components/shared/PageStub';

export const Route = createFileRoute('/admin/integrations')({
  component: () => <PageStub title="Integrations" description="Third-party app connections" />,
});
